import type { ReactNode } from 'react';
import { BookShellReactContext } from './book-shell-context';
import type { BookShellContext } from './types';

/**
 * BookShellContextProvider — wraps children with the current shell
 * context. BookShell places this around its `<Outlet />` so every
 * book route reads the same envelope / loading / error / refetch
 * shape via `useBookShellContext`.
 *
 * The hook + error class + createContext live in
 * `./book-shell-context.ts` (non-JSX); this file exports ONLY the
 * Provider component so `react-refresh/only-export-components` is
 * satisfied and Fast Refresh keeps working across the whole book
 * feature module.
 */

export interface BookShellContextProviderProps {
  readonly value: BookShellContext;
  readonly children: ReactNode;
}

export function BookShellContextProvider({ value, children }: BookShellContextProviderProps) {
  return <BookShellReactContext.Provider value={value}>{children}</BookShellReactContext.Provider>;
}
